import { useContext, useEffect, useState } from 'react';
import { Button } from 'react-bootstrap';
import { useHistory } from 'react-router';
import styled, { useTheme } from 'styled-components';

import CheckMark from '../../assets/svg/disc/check-disc.svg';
import { AppContext } from '../../context/AppContext';
import { min } from '../../utils/breakpoints';

const StyledImg = styled.img`
  width: 50px;

  ${min.sm} {
    width: 80px;
  }
`;

const ConnectedContainer = () => {
  const { subscriptionsDisabled } = useContext(AppContext);
  const [next, setNext] = useState();
  const theme = useTheme();
  const history = useHistory();

  useEffect(() => {
    if (subscriptionsDisabled) {
      setNext('/onboarding/finalising');
    } else {
      setNext('/onboarding/subscription');
    }
  }, []);

  return (
    <>
      <h1 className="mb-3">Connected to your system</h1>
      <div className="mt-1 mb-4">
        <StyledImg src={CheckMark} alt="Success checkmark" />
      </div>
      <p className="mb-0">{theme.language.appName} has successfully connected to your inverter.</p>
      <Button className="mb-2" onClick={() => history.push(next)}>
        Continue
      </Button>
    </>
  );
};

export default ConnectedContainer;
